<div class="flex justify-end">
  <app-close-chip (closed)="close()" />
</div>
<h2 mat-dialog-title>{{ "components.edenred_recharge_modal.title" | translate: { walletName: walletName } }}</h2>
<mat-dialog-content class="!pt-2">
  <p class="text-sm font-normal text-default-gray m-0 mb-4" [innerHTML]="'components.edenred_recharge_modal.disclaimer' | translate"></p>
  <mat-form-field class="w-full" appearance="outline">
    <mat-label>{{"components.edenred_recharge_modal.form_field_title" | translate}}</mat-label>
    <input matInput type="number" [min]="minimumRechargeAmount" [max]="maximumRechargeAmount" [(ngModel)]="amount">
    <mat-hint [innerHTML]="'components.edenred_recharge_modal.form_field_hint' | translate: { minAmount: minimumRechargeAmount, maxAmount: maximumRechargeAmount }"></mat-hint>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" type="button" [disabled]="!amountIsValid || rechargeInProgress" (click)="onSend()">
    {{ "components.edenred_recharge_modal.recharge_button" | translate | uppercase }}
  </button>
</mat-dialog-actions>
